<template>
  <button
    :disabled="loading || disabled"
    class="btn-loading"
    :class="{ loading: loading }"
  >
    <div v-if="loading" :class="`spinner-grow ${small ? 'spinner-sm' : ''}`" role="status">
      <span class="sr-only">Loading...</span>
    </div>
    <slot v-else />
  </button>
</template>

<script>
export default {
  props: {
    loading: Boolean,
    disabled: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
